import axios from "axios";

const clippyClient = axios.create({
  baseURL: process.env.REACT_APP_CLIPPY_URL
});

export default clippyClient;
